// TODO: Add more globals as needed and implement globals everywhere

/**
 * @typedef MuiThemeGlobals
 *
 * @property {number} topBarHeightDesktopTotal - The total height of the top bar on desktop
 * @property {number} topBarHeightDesktop - The height of the top bar on desktop
 * @property {number} bottomBarHeight - The height of the bottom bar
 * @property {number} bottomBarElementsSpacing - The spacing between the elements of the bottom bar
 * @property {number} bannerHeight - The height of the banner
 *
 * @property {number} zIndexTopBar - The z-index of the top bar
 * @property {number} zIndexGenericError - The z-index of the generic error
 * @property {number} zIndexCookieBanner - The z-index of the cookie banner
 * @property {number} zIndexMobileFilters - The z-index of the mobile filters (listings view)
 * @property {number} zIndexMobileMapFilters - The z-index of the mobile filters bar overlaying the map
 * @property {number} zIndexHeroScrollBar - The z-index of the hero scroll bar
 * @property {number} zIndexFilterBox - The z-index of the filter box
 * @property {number} zIndexToggleMapMobileButton - The z-index of the toggle map mobile button
 * @property {number} zIndexStoryblokHerosearchPreset - The z-index of the storyblok hero search preset
 * @returns {MuiThemeGlobals} - The globals object
 */
export const createGlobals = () => ({
  zIndexGenericError: 200, // Errors should be above everything else
  zIndexCookieBanner: 200,
  zIndexHeroScrollBar: 90,
  zIndexMobileFilters: 80, // listings view; MAP is 100 in mobile
  zIndexMobileMapFilters: 110, // must stay above the mobile map modal (z-index 100) so the filter bar overlays it
  zIndexFilterBox: 120,
  zIndexToggleMapMobileButton: 130,
  zIndexStoryblokHerosearchPreset: 90,
  zIndexTopBar: 10,

  bannerHeight: 5,
  bottomBarHeight: 80,
  topBarHeightDesktop: 72,
  topBarHeightDesktopTotal: 72 + 44,

  bottomBarElementsSpacing: 32,
});
